import React, { useState } from 'react'
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import defaultimg from "../../Assets/Images/default-placeholder.png";
import { useNavigate } from 'react-router-dom';
import SelectShippingOffCanvas from '../offCanvas/selectShippingOffCanvas';
export const ServiceCard = ({ data, forCart }) => {

    const navigate = useNavigate();
    const [showModel, setShowModel] = useState(false)

    const toggleOffCanvas = () => {
        setShowModel(!showModel)
    }
    // console.log('data---', data);
    // console.log('forCart---', forCart);
    return (
        <>
            <div className="componentServiceCard ProductServiceCardMedium">
                <div className="ServiceCardContainer">
                    <div className="serviceCardBody">

                        <div className="serviceDetails">
                            <div className="serviceName fs-12">
                                {data?.service_name?.length > 24
                                    ? data.service_name.slice(0, 24) + "..."
                                    : data?.service_name}
                            </div>

                            <div className="price fs-11">
                                <span className="rupeeIcon">₹</span>{data?.service_price}
                            </div>

                            <div className="category fs-10">
                                {data?.service_category_name?.toUpperCase()}
                            </div>

                            {/* <div className="moreDetails d-flex align-items-center fs-11">
                                <span>Read More</span>
                                <IoIosArrowDown size={16} />
                            </div> */}
                        </div>

                        <div className="serviceCardImgBox">
                            <img
                                src={data?.image_url || defaultimg}
                                className="serviceImageMedium"
                                onError={(e) => (e.currentTarget.src = defaultimg)}
                                alt=""
                            />
                            <button className="serviceSelectBtn" onClick={() => toggleOffCanvas()}>select</button>
                        </div>

                    </div>
                </div>
            </div>

            {
                showModel &&
                <SelectShippingOffCanvas isOpen={showModel}  toggleOffCanvas={toggleOffCanvas} forCart={forCart} data={data} />
            }
        </>
    );
};

